import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';

import useRoom from '../useRoom';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const {
    form,
    updateInProcess,
    handleCreateOrUpdate,
    companies,
    inactiveCompanies,
    asset,
  } = useRoom(false);

  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew ? t('CREARE UNITA') : t('MODIFICA UNITA');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          onFieldsChange={(changedFields) => {
            form.setFields([
              {
                name: changedFields[0].name[0],
                errors: [],
              },
            ]);
          }}
          initialValues={{
            leasings_asset_id: '',
            status: '',
            company_id: '',
            company_note: '',
            title: '',
            plant_ac: '',
            plant_ac_note: '',
            gla: '',
            plant_lights: '',
            plant_lights_note: '',
            sales_area: '',
            plant_anti_theft: '',
            plant_anti_theft_note: '',
            finish: '',
            furniture: '',
            furniture_note: '',
            wc: '',
            wc_note: '',
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <InfoSection
            companies={companies}
            inactiveCompanies={inactiveCompanies}
            asset={asset}
          />
        </Form>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onClickSave}
              width={'150px'}
              big
              icon={<CheckOutlined />}
              loading={updateInProcess}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Edit;
